<ng-container *transloco="let t; read: 'user'">
<div class="w-max">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ t('dashboard.portfolio.futureEvidence.title') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <div class="mt-2">
      {{ t('dashboard.portfolio.futureEvidence.savedInLibrary') }} <br>
      {{ t('dashboard.portfolio.futureEvidence.clickChildName') }} <br>
      {{ t('dashboard.portfolio.futureEvidence.addNewHint') }}
    </div>
    <ul class="student-list">
      @for (student of studentList; track student) {
        <li (click)="redirectToEvidence(student)">
          <a>{{student.name}}</a>
        </li>
      }
    </ul>
  </div>
  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn type="submit" mat-dialog-close color="outline" class="mr-2">{{ t('dashboard.portfolio.actions.cancel') }}</drdp-btn>
    <drdp-btn type="button" (click)="goToNextPage()">{{ t('dashboard.portfolio.futureEvidence.addNew') }}</drdp-btn>
  </div>
</div>
</ng-container>
